export default function () {
  this.loadInvites()
}
